var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9995 7C17.9995 10.3137 15.3132 13 11.9995 13C8.6858 13 5.99951 10.3137 5.99951 7C5.99951 3.68629 8.6858 1 11.9995 1C15.3132 1 17.9995 3.68629 17.9995 7ZM15.9995 7C15.9995 9.20914 14.2087 11 11.9995 11C9.79037 11 7.99951 9.20914 7.99951 7C7.99951 4.79086 9.79037 3 11.9995 3C14.2087 3 15.9995 4.79086 15.9995 7Z",
    fill: "#B0B8C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9996 14C9.06446 14 6.94821 14.6088 5.43015 15.5217C3.90604 16.4383 3.04998 17.6224 2.57724 18.6581C2.17876 19.5311 2.36012 20.4207 2.88956 21.0546C3.39422 21.6587 4.17891 22 4.99956 22H18.9995C19.8202 22 20.6048 21.6588 21.1095 21.0546C21.6389 20.4208 21.8203 19.5311 21.4219 18.6582C20.9491 17.6225 20.0931 16.4383 18.569 15.5218C17.051 14.6088 14.9347 14 11.9996 14ZM4.39666 19.4886C4.72482 18.7697 5.32761 17.9172 6.46086 17.2357C7.60017 16.5506 9.33979 16 11.9996 16C14.6594 16 16.399 16.5506 17.5383 17.2357C18.6715 17.9172 19.2743 18.7697 19.6024 19.4886C19.6412 19.5735 19.6395 19.6245 19.6356 19.6506C19.6311 19.6803 19.6165 19.7222 19.5746 19.7724C19.4844 19.8804 19.2834 20 18.9995 20H4.99956C4.71563 20 4.51467 19.8804 4.42451 19.7724C4.38253 19.7222 4.36793 19.6803 4.36349 19.6506C4.3596 19.6245 4.35791 19.5735 4.39666 19.4886Z",
    fill: "#B0B8C1"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettings);
export default __webpack_public_path__ + "static/media/icon-settings.cccd871e009662299b2ef903818bd5d7.svg";
export { ForwardRef as ReactComponent };